module.exports = __webpack_public_path__ + "img/refresh.bbe673f2.png";